import React, { useEffect, useState } from "react";
import integrationsService from "../../../services/integrationsService";
import LoadingSpinner from "../../common/LoadingSpinner";
import { formatInUserTimezone } from "../../../utils/timezone";

function SyncActivityTab() {
  const [loading, setLoading] = useState(true);
  const [batches, setBatches] = useState([]);
  const [error, setError] = useState("");
  const [detail, setDetail] = useState(null);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await integrationsService.listSyncBatches();
      setBatches(Array.isArray(res?.data) ? res.data : []);
    } catch (e) {
      setError(e?.response?.data?.error || "Failed to load sync activity");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  if (loading) return <LoadingSpinner message="Loading sync activity..." />;

  return (
    <div>
      <div className="management-header">
        <div>
          <h2>Sync Activity</h2>
          <p className="text-muted">
            Every intake batch: API, file, and internal Bulk Import.
          </p>
        </div>
        <button className="btn btn-secondary" onClick={load}>
          <i className="fas fa-sync-alt" /> Refresh
        </button>
      </div>

      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle" /> {error}
        </div>
      )}

      {batches.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-stream" />
          <h3>No sync activity yet</h3>
          <p>Batches will appear here as external systems push data.</p>
        </div>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Batch</th>
                <th>Transport</th>
                <th>API Key</th>
                <th>Processed</th>
                <th>Created</th>
                <th>Merged</th>
                <th>Conflicts</th>
                <th>Rejected</th>
                <th>Status</th>
                <th>Started</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((b) => (
                <tr key={b.id}>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => setDetail(b)}
                    >
                      <code>{b.batch_id}</code>
                    </button>
                  </td>
                  <td>{b.transport}</td>
                  <td>{b.api_key_label || "—"}</td>
                  <td>{b.processed}</td>
                  <td>{b.created_count}</td>
                  <td>{b.merged_count}</td>
                  <td>{b.conflict_count}</td>
                  <td>{b.rejected_count}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        b.status === "completed"
                          ? "active"
                          : b.status === "failed"
                            ? "inactive"
                            : ""
                      }`}
                    >
                      {b.status}
                    </span>
                  </td>
                  <td>{formatInUserTimezone(b.started_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {detail && (
        <div className="modal-overlay" onMouseDown={() => setDetail(null)}>
          <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
            <h2>Batch Detail</h2>
            <div className="detail-row">
              <span className="label">Batch ID</span>
              <span className="value"><code>{detail.batch_id}</code></span>
            </div>
            <div className="detail-row">
              <span className="label">Transport</span>
              <span className="value">{detail.transport}</span>
            </div>
            <div className="detail-row">
              <span className="label">File</span>
              <span className="value">{detail.file_name || "—"}</span>
            </div>
            <div className="detail-row">
              <span className="label">Processed</span>
              <span className="value">{detail.processed}</span>
            </div>
            <div className="detail-row">
              <span className="label">Created</span>
              <span className="value">{detail.created_count}</span>
            </div>
            <div className="detail-row">
              <span className="label">Merged</span>
              <span className="value">{detail.merged_count}</span>
            </div>
            <div className="detail-row">
              <span className="label">Conflicts</span>
              <span className="value">{detail.conflict_count}</span>
            </div>
            <div className="detail-row">
              <span className="label">Rejected</span>
              <span className="value">{detail.rejected_count}</span>
            </div>
            <div className="detail-row">
              <span className="label">Status</span>
              <span className="value">{detail.status}</span>
            </div>
            {detail.error_message && (
              <div className="detail-row">
                <span className="label">Error</span>
                <span className="value" style={{ color: "#a83232" }}>
                  {detail.error_message}
                </span>
              </div>
            )}
            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={() => setDetail(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SyncActivityTab;